export enum TermTypeEnum {
  GENERAL_DISCLAIMER = "GENERAL_DISCLAIMER",
  AIRLINE_DISCLAIMER = "AIRLINE_DISCLAIMER",
  VALIDATION_DISCLAIMER = "VALIDATION_DISCLAIMER",
  VALIDATION_DISCLAIMER_CHECKBOX = "VALIDATION_DISCLAIMER_CHECKBOX",
}
